import { persistStore } from 'redux-persist';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

import store from './index';

export const persistor = persistStore(store, null, () => {
  store.dispatch(UndoActionCreators.clearHistory());
});
